export const PASSPORT_SERIES_SEPARATOR = " серия ";

export const PASSPORT_SERIES_PLACEHOLDER = "MP";
export const PASSPORT_NUMBER_PLACEHOLDER = "Введите номер";

export const sanitizePassportSeries = (value) =>
    String(value ?? "").replace(/[^A-Za-zА-Яа-яЁё]/g, "");

export const sanitizePassportNumber = (value) =>
    String(value ?? "").replace(/\D/g, "");

export const parsePassport = (passport) => {
    const value = (passport ?? "").trim();
    if (!value) {
        return {series: "", number: ""};
    }

    const legacyIndex = value.indexOf(PASSPORT_SERIES_SEPARATOR);
    if (legacyIndex !== -1) {
        return {
            series: sanitizePassportSeries(value.slice(legacyIndex + PASSPORT_SERIES_SEPARATOR.length)),
            number: sanitizePassportNumber(value.slice(0, legacyIndex)),
        };
    }

    const compact = value.replace(/\s+/g, "");
    const match = compact.match(/^([A-Za-zА-Яа-яЁё]+)(\d*)$/i);
    if (match) {
        return {
            series: match[1],
            number: match[2],
        };
    }

    if (/^\d+$/.test(compact)) {
        return {series: "", number: compact};
    }

    if (/^[A-Za-zА-Яа-яЁё]+$/i.test(compact)) {
        return {series: compact, number: ""};
    }

    return {series: "", number: sanitizePassportNumber(compact)};
};

export const combinePassport = (series, number) => {
    const trimmedSeries = sanitizePassportSeries(series);
    const trimmedNumber = sanitizePassportNumber(number);
    if (!trimmedSeries && !trimmedNumber) {
        return "";
    }
    if (!trimmedSeries) {
        return trimmedNumber;
    }
    if (!trimmedNumber) {
        return trimmedSeries;
    }
    return `${trimmedSeries}${trimmedNumber}`;
};

export const buildPassportPayload = (passportValue) =>
    combinePassport(...Object.values(parsePassport(passportValue)));

export const sanitizePassportInput = (value) => {
    const compact = String(value ?? "").replace(/\s+/g, "");
    const lettersMatch = compact.match(/^[A-Za-zА-Яа-яЁё]*/i);
    const letters = lettersMatch ? lettersMatch[0] : "";
    const series = sanitizePassportSeries(letters).slice(0, 4);
    if (!series) {
        return "";
    }
    const number = sanitizePassportNumber(compact.slice(letters.length));
    return combinePassport(series, number);
};

export const validatePassportString = (passport) => {
    const {series, number} = parsePassport(passport);
    return validatePassportParts(series, number);
};

export const validatePassportParts = (series, number) => {
    const sanitizedSeries = sanitizePassportSeries(series);
    const sanitizedNumber = sanitizePassportNumber(number);

    if (!sanitizedSeries && !sanitizedNumber) {
        return "";
    }
    if (!sanitizedSeries) {
        return "укажите серию паспорта";
    }
    if (!sanitizedNumber) {
        return "укажите номер паспорта";
    }
    if (!/^[A-Za-zА-Яа-яЁё]+$/i.test(sanitizedSeries)) {
        return "серия должна содержать только буквы";
    }
    if (!/^\d+$/.test(sanitizedNumber)) {
        return "номер должен содержать только цифры";
    }
    return "";
};
